'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSmokeFree = function MdSmokeFree(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 26.6l-5-5h5v5z m-4.3-12.1c-3 0-5.5-2.5-5.5-5.6s2.5-5.5 5.5-5.5v2.5c-1.7 0-3 1.1-3 2.9s1.3 3.3 3 3.3h2.6c3.1 0 5.8 2.3 5.8 5.2v2.7h-2.5v-2.1c0-2.2-1.6-3.4-3.3-3.4h-2.6z m7.3-6.4c3.1 1.5 5.2 4.7 5.2 8.5v3.4h-2.5v-3.4c0-3.8-2.8-6.8-6.6-6.8v-2.5c1.7 0 3.1-1.4 3.1-3.2h2.5c0 1.6-0.7 3-1.7 4z m-1.4 13.5h2.5v5h-2.5v-5z m4.1 0h2.5v5h-2.5v-5z m-30.7-11.6l2-2.1 28.4 28.4-2.2 2.1-11.6-11.8h-16.6v-5h11.6z' })
        )
    );
};

exports.default = MdSmokeFree;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/smoke-free.js
// module id = 1204
// module chunks = 0